'use client';

import type { SlotLinkProps } from '../Base/Slot.Link';
import { SlotLink } from '../Base/Slot.Link';
import { usePaybackLink } from '../../shared/usePaybackLink';

export const PaybackSlot = (props: Pick<SlotLinkProps, 'priority'>) => {
  const { href, label } = usePaybackLink();

  return (
    <SlotLink {...props} href={href} label={label}>
      <div className="icon-emp-payback-colored h-4 w-4" />
    </SlotLink>
  );
};
